(() => {
  const SELECTOR = 'select.vw-phone-model-select';

  function normalizeModelSelect(root = document) {
    const selects = [];
    if (root instanceof Element && root.matches(SELECTOR)) selects.push(root);
    if (root.querySelectorAll) selects.push(...root.querySelectorAll(SELECTOR));

    selects.forEach((select) => {
      if (select.dataset.vwModelPickerReady === 'true') return;
      select.dataset.vwModelPickerReady = 'true';

      const selectedByAttribute = select.querySelector('option[selected]');
      const fallback = select.options[0];
      if (selectedByAttribute || !fallback) return;

      fallback.selected = true;
      fallback.setAttribute('selected', 'selected');
      queueMicrotask(() => {
        if (!select.isConnected) return;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeModelSelect(), { once: true });
  } else {
    normalizeModelSelect();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) normalizeModelSelect(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
